var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liquid-circle"},[_vm._v(" 雪亮圈子 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }